"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SnapOverlayOp = _interopRequireDefault(require("./SnapOverlayOp"));

var _RuntimeException = _interopRequireDefault(require("../../../../../../java/lang/RuntimeException"));

var _OverlayOp = _interopRequireDefault(require("../OverlayOp"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SnapIfNeededOverlayOp =
/*#__PURE__*/
function () {
  function SnapIfNeededOverlayOp() {
    _classCallCheck(this, SnapIfNeededOverlayOp);

    SnapIfNeededOverlayOp.constructor_.apply(this, arguments);
  }

  _createClass(SnapIfNeededOverlayOp, [{
    key: "getResultGeometry",
    value: function getResultGeometry(opCode) {
      var result = null;
      var isSuccess = false;
      var savedException = null;

      try {
        result = _OverlayOp.default.overlayOp(this._geom[0], this._geom[1], opCode);
        var isValid = true;
        if (isValid) isSuccess = true;
      } catch (ex) {
        if (ex instanceof _RuntimeException.default) {
          savedException = ex;
        } else throw ex;
      } finally {}

      if (!isSuccess) {
        try {
          result = _SnapOverlayOp.default.overlayOp(this._geom[0], this._geom[1], opCode);
        } catch (ex) {
          if (ex instanceof _RuntimeException.default) {
            throw savedException;
          } else throw ex;
        } finally {}
      }

      return result;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SnapIfNeededOverlayOp;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "overlayOp",
    value: function overlayOp(g0, g1, opCode) {
      var op = new SnapIfNeededOverlayOp(g0, g1);
      return op.getResultGeometry(opCode);
    }
  }, {
    key: "union",
    value: function union(g0, g1) {
      return SnapIfNeededOverlayOp.overlayOp(g0, g1, _OverlayOp.default.UNION);
    }
  }, {
    key: "intersection",
    value: function intersection(g0, g1) {
      return SnapIfNeededOverlayOp.overlayOp(g0, g1, _OverlayOp.default.INTERSECTION);
    }
  }, {
    key: "symDifference",
    value: function symDifference(g0, g1) {
      return SnapIfNeededOverlayOp.overlayOp(g0, g1, _OverlayOp.default.SYMDIFFERENCE);
    }
  }, {
    key: "difference",
    value: function difference(g0, g1) {
      return SnapIfNeededOverlayOp.overlayOp(g0, g1, _OverlayOp.default.DIFFERENCE);
    }
  }]);

  return SnapIfNeededOverlayOp;
}();

exports.default = SnapIfNeededOverlayOp;

SnapIfNeededOverlayOp.constructor_ = function () {
  this._geom = new Array(2).fill(null);
  var g1 = arguments[0],
      g2 = arguments[1];
  this._geom[0] = g1;
  this._geom[1] = g2;
};